module.exports = __webpack_public_path__ + "static/media/parrotnews.19b97424.png";